/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Features_Desk_FreeInputs */

const en_features_desk_free = /** @type {(inputs: Features_Desk_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} free hours`)
};

const pl_features_desk_free = /** @type {(inputs: Features_Desk_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wolnych godzin`)
};

/**
* | output |
* | --- |
* | "{count} free hours" |
*
* @param {Features_Desk_FreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_free = /** @type {((inputs: Features_Desk_FreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_FreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_free(inputs)
	return en_features_desk_free(inputs)
});